import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import DynamicFormHeaderForReport from './DynamicFormHeaderForReport';

export default function ReportReviewForm({
  dynamicForm,
  eventId,
  original,
  hideSignatures,
}) {
  return (
    <div>
      <ReportSectionTitle title={dynamicForm.Name} />
      <DynamicFormHeaderForReport
        dynamicForm={dynamicForm}
        eventId={eventId}
        original={original}
        hideSignatures={hideSignatures}
      />
    </div>
  );
}
